import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import useCommonStyles from './useCommonStyles';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.typography.subtitle2,
  },
  inactive: {
    color: theme.palette.neutrals[4],
  },
  tertiary: {
    color: theme.palette.primary.A700,
  },
}));

const Subtitle2 = ({ children, center, right, white, selected, inactive, secondary, tertiary, oneLine, className, ...props }) => {
  const classes = useStyles();
  const common = useCommonStyles();

  return (
    <Typography
      variant="subtitle2"
      classes={{ root: classes.root }}
      className={clsx({
        [common.center]: center,
        [common.right]: right,
        [common.white]: white || selected || secondary,
        [classes.inactive]: inactive,
        [classes.tertiary]: tertiary,
        [common.wrapEllipsis]: oneLine,
        [className]: className.length > 0,
      })}
      {...props}
    >
      {children}
    </Typography>
  );
};

Subtitle2.defaultProps = {
  center: false,
  right: false,
  white: false,
  selected: false,
  inactive: false,
  secondary: false,
  tertiary: false,
  oneLine: false,
  className: '',
};

Subtitle2.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]).isRequired,
  center: PropTypes.bool,
  right: PropTypes.bool,
  white: PropTypes.bool,
  selected: PropTypes.bool,
  inactive: PropTypes.bool,
  secondary: PropTypes.bool,
  tertiary: PropTypes.bool,
  oneLine: PropTypes.bool,
  className: PropTypes.string,
};

export default Subtitle2;
